<template>
  <div v-wechat-title="cateName" class="classify-page">
    <div class="content-box">
      <div class="box1">
        <search @search="onSearch"></search>
      </div>
      <van-image v-if="adsImage" :src="adsImage" height="100" lazy-load></van-image>
      <MallSortTable ref="list" :cate-id="cateId" />
    </div>
  </div>
</template>

<!--todo::这个页面需要添加分页-->

<script>
import Vue from "vue";
import { api_get_cate_by_id, } from "@/api/goods-api";
import GoodsUnit from "@/components/common/goods-unit";
import { Lazyload } from "vant";
import MallSortTable from "@/components/common/MallSortTable";

Vue.use(Lazyload);

export default {
  name: "goods-list-ecoupo",
  components: { MallSortTable, GoodsUnit },

  data() {
    return {
      keyword: "",
      goodsList: [],
      cateId: 1,
      adsImage: "",
      cateName: "",
    };
  },

  created() {
    this.cateId = Number(this.$route.query.cateId) || 0;
    api_get_cate_by_id(this.cateId).then((res) => {
      this.cateName = res.data.name;
      this.adsImage = res.data.adsImage;
    });
  },

  methods: {
    onSearch(val) {
      this.$refs.list.search(val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
